import { Table as AntdTable } from 'antd';
import styled from 'styled-components';

export const StyledTable = styled(AntdTable)<any>`
  & .ant-table {
    border-radius: 0 20px 0 20px;
    box-shadow: ${(props) => (props.bordered === false ? '' : '0 4px 0 0 rgba(0, 0, 0, 0.1)')};
    overflow: hidden;

    & .ant-table-thead {
      box-shadow: 0 1px 0 0 ${(props) => props.theme.Table.colorHeaderBorder};

      & .ant-table-cell,
      & .ant-table-column-title {
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
      }

      & .ant-table-cell {
        &:first-child {
          padding-left: 24px;
        }

        &:last-child {
          padding-right: 24px;
        }
      }
    }

    & .ant-table-tbody {
      & .ant-table-cell {
        font-size: 14px;
        line-height: 18px;

        &:first-child {
          padding-left: 24px;
        }

        &:last-child {
          padding-right: 24px;
        }
      }
    }
  }
`;
